<div class="content-page">
  <app-aside
    messageBackground="Validar seu acesso com o código enviado garante a segurança do processo"
  ></app-aside>

  <main class="main-page">
    <div class="container">
      <app-top-bar
        [hideMenu]="menu ? false : true"
        TextoTopo="Identificação"
        action="/cadastro/lgpd"
      ></app-top-bar>
      <app-step-timeline
        [itemActive]="2"
        [itens]="['Cadastro', 'Preferências', 'Código', 'Senha']"
      ></app-step-timeline>
      <div class="row">
        <div class="col-1"></div>
        <div class="col-10">
          <h1 class="TtlPrin text-center mb-32">
            {{ title }}
          </h1>
          <p class="SubTtl text-center mb-32">
            Informe a senha enviada para o número
            <strong>{{ token.phone }}</strong
            >.
          </p>
          <div class="modal-link text-center mb-64">
            <a (click)="openDialogContact()">Não é o meu número</a>
          </div>
        </div>
        <div class="col-1"></div>
      </div>

      <div class="row">
        <div class="col"></div>
        <div class="col col-md-6">
          <form [formGroup]="confirmationFormGroup" (ngSubmit)="onSubmit()">
            <span>Código</span>
            <div class="items-token mb-2">
              <mat-form-field
                class="InputPadrao"
                *ngFor="let digit of digits; let i = index"
              >
                <input
                  matInput
                  maxlength="1"
                  mask="0"
                  type="tel"
                  inputmode="numeric"
                  placeholder="&mdash;"
                  autocomplete="off"
                  [value]="values[digit - 1]"
                  [autofocus]="autofocus == true && digit === 1"
                  [attr.tabindex]="digit > 1 ? -1 : undefined"
                  (keydown)="handleKeyDownEvent($event, i)"
                  (paste)="handlePasteEvent($event)"
                />
              </mat-form-field>
            </div>
            <div class="box-info">
              <img src="../../../../assets/svg/icon-info.svg" alt="icon info" />
              <p>
                A senha pode demorar até 2 minutos para chegar. Caso demore mais
                que isso, clique em reenviar
              </p>
            </div>
            <a
              (click)="openDialogResendPassword()"
              class="mt-5 d-block text-cemter"
              >Reenviar código <span *ngIf="count">(em {{ count }}s)</span></a
            >
            <div class="d-flex justify-content-center">
              <button
                class="Btn BtnPadrao"
                [disabled]="!confirmationFormGroup.valid"
                type="submit"
                mat-button
                matStepperNext
              >
                Validar acesso
              </button>
            </div>
          </form>
        </div>
        <div class="col"></div>
      </div>
    </div>
    <app-footer></app-footer>
  </main>
</div>
